<template>
  <div>
    <div class="wrapper" v-if="!next">
      <div class="logo">
        <img src="./logo.png" alt="" class="img">
      </div>
      <h3 class="sign-tip">
        注册
      </h3>
      <div class="sign-box">
        <div class="title">请填写手机号</div>
        <div class="sign-input">
          <el-input v-model="phone" type="number" placeholder="请填写手机号" maxlength="11"></el-input>
        </div>
        <div class="title">请输入短信验证码</div>
        <div class="sign-input sms flex">
          <el-input v-model="code" placeholder="请输入短信验证码"></el-input>
          <el-button class="time" size='small' type="primary" @click="handleGet" v-show="time==61">获取验证码</el-button>
          <el-button class="time" size='small' type="primary" v-show="time<61&&time>0">{{ time }}秒后重试</el-button>
        </div>
        <el-button class="btn" type="primary" size='small' @click="handleNext">下一步</el-button>
      </div>
    </div>
    <div class="wrapper" v-else>
      <div class="logo">
        <img src="./logo.png" alt="" class="img">
      </div>
      <h3 class="sign-tip">
        请设置用户名和密码
      </h3>
      <div class="sign-box">
        <div class="title">请设置用户名
          <span class="tip">用户名设置后不可修改</span>
        </div>
        <div class="sign-input">
          <el-input v-model="userName" placeholder="请输入用户名"></el-input>
        </div>
        <div class="title">请设置密码</div>
        <div class="sign-input">
          <el-input v-model="password" show-password placeholder="请输入密码"></el-input>
        </div>
        <div class="title">请再次输入以确定密码</div>
        <div class="sign-input">
          <el-input v-model="confim" show-password placeholder="请确认密码"></el-input>
        </div>
        <el-button class="btn" type="primary" size="small" @click="sign">完成</el-button>
      </div>
      <div class="agreement">
        <el-checkbox v-model="agree">同意&nbsp;
          <span @click="isShow=!isShow" class="color">《软件及服务协议》</span>
        </el-checkbox>
      </div>
      <v-agree :isShow="isShow"></v-agree>
    </div>
  </div>
</template>

<script>
import VAgree from './Agreement.vue'

const url = 'https://new.shaobing.ltd/api/v1/'
const validPhone = (phone) => {
  const reg = /^1[3-9]\d{9}$/
  return reg.test(phone)
}
const validatePass = (password) => {
  const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
  return reg.test(password)
}
export default {
  components: {VAgree},
  data () {
    return {
      phone: '',
      code: '',
      next: false,
      time: 61,
      timer: null,
      userName: '',
      password: '',
      confim: '',
      agree: false,
      isShow: false,
      weChatcode: ''
    }
  },
  watch: {
    time (val) {
      if (val === 0) {
        clearInterval(this.timer)
        this.timer = null
        this.time = 61
      }
    }
  },
  created () {
    console.log('code', this.getUrlParams().code)
  },
  methods: {
    // 获取code
    getUrlParams () {
      var url = location.search
      var urlParams = {}
      if (url.indexOf('?') !== -1) {
        var str = url.substr(1)
        var strs = str.split('&')
        for (var i = 0; i < strs.length; i++) {
          urlParams[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
        }
      }
      this.weChatcode = urlParams.code
      return urlParams
    },
    handleAgree () {
      this.agree = true
    },
    handleGet () {
      this.timer && clearInterval(this.timer)
      this.timer = null
      if (this.phone && validPhone(this.phone)) {
        this.axios.post(url + 'user/account/sms?phone=' + this.phone).then((res) => {
          if (res.data.data) {
            this.$message.success('短信验证码发送成功')
            this.time = 60
            this.timer = setInterval(() => {
              this.time--
            }, 1000)
          } else {
            this.$message.error(res.data.message)
          }
        })
      } else {
        this.$message.error('请输入11位合法手机号')
      }
    },
    sign () {
      if (this.userName.trim()) {
        this.axios.post(url + 'user/login/validationUsername?username=' + this.userName).then((res) => {
          if (res.data.data) {
            if (!this.password || !this.confim) {
              this.$message.error('请填写密码')
              return
            } else if (!validatePass(this.password)) {
              this.$message.error('密码必须是6-16位的数字或字母的组合')
              return
            } else if (this.password != this.confim) {
              this.$message.error('密码不一致，请确认')
              return
            } else if (!this.agree) {
              this.$message.error('请先阅读并同意软件服务协议')
              return
            } else {
              this.axios.post(url + 'wxoa/registerAndBindAccount?password=' + this.password + '&userName=' + this.userName
                + '&phone=' + this.phone + '&code=' + this.weChatcode).then((res) => {
                if (res.data.code == 200) {
                  this.$message.success('用户名注册成功')
                } else {
                  this.$message.error(res.data.message)
                }
                setTimeout(() => {
                  window.WeixinJSBridge.call('closeWindow')
                }, 2000)
              })
            }
          } else {
            this.$message.error('用户名错误')
            return
          }
        })
      } else {
        this.$message.error('请填写用户名')
        return
      }
    },
    handleNext () {
      if (this.code) {
        this.axios.post(url + 'user/login/validationCode?phone=' + this.phone + '&code=' + this.code).then((res) => {
          if (res.data.data) {
            this.$message.success('手机号验证成功')
            this.next = true
          } else {
            this.$message.error(res.data.message)
          }
        })
      } else {
        this.$message.error('请先输入验证码')
      }
    }
  }

}
</script>

<style scoped>
.flex {
  display: flex;
}

.wrapper {
  text-align: center;
  padding: 20px 0 40px;
  height: 100vh;
  width: 100vw;
  background-color: #fff;
  font-family: "Times New Roman", serif;
  touch-action: none;
}

.img {
  width: 50px;
  height: 50px;
}

.btn {
  width: 100%;
  margin-top: 20px;
  background: #8AE4D8;
  border-color: #8AE4D8;
}

.time {
  margin-left: 10px;
  background: #8AE4D8;
  border-color: #8AE4D8;
}

.sign-tip {
  margin: 20px;
  text-align: center;
}

.sign-box {
  background: #F6F8FA;
  border: 1px solid #E4E7EA;
  border-radius: 6px;
  padding: 20px;
  margin: 20px 30px;
  text-align: left;
}

.tip {
  color: #8AE4D8;
  margin-left: 20px;
  font-size: 14px;
}

.link {
  color: #8AE4D8;
}

.title {
  line-height: 30px;
}

.sign-input {
  height: 30px;
  line-height: 30px;
  margin: 5px 0;
}

.logo {
  width: 60px;
  height: 60px;
  margin: 20px auto;
}

.img {
  width: 100%;
  height: 100%;
}

.sign-input >>> .el-input .el-input__inner {
  height: 30px !important;
  line-height: 30px !important;
}

::v-deep .sms .el-input {
  width: 60%;
}

.agreement >>> .el-checkbox__input.is-checked .el-checkbox__inner {
  background: #8AE4D8 !important;
  border-color: #8AE4D8 !important;
  color: #8AE4D8 !important;
}

.agreement >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #8AE4D8;
}

.color {
  color: #8AE4D8;
}

.time >>> .el-button--primary:focus, .el-button--primary:hover,
.btn >>> .el-button--primary:focus, .el-button--primary:hover {
  background: #8AE4D8 !important;
  border-color: #8AE4D8 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue